import {
  computeProfileCompletion as computeFromEngine,
  computeProfileCompletionPercent as computePercentFromEngine,
  getProfileCompletionChecks as getChecksFromEngine
} from '../shared/profileCompletionEngine.js';
import { candidateApiToForm } from './candidatePayload';

export {
  PROFILE_COMPLETION_RULES,
  normalizeProfileForm,
  languagesComplete
} from '../shared/profileCompletionEngine.js';

function normalizeCandidate(candidate, user) {
  if (!candidate) return null;
  return candidate?.personal || candidate?.contact
    ? candidateApiToForm(candidate, user)
    : candidate;
}

export function getProfileCompletionChecks(form, user) {
  return getChecksFromEngine(normalizeCandidate(form, user), user);
}

export function computeProfileCompletion(candidate, user) {
  return computeFromEngine(normalizeCandidate(candidate, user), user);
}

export function computeProfileCompletionPercent(candidate, user) {
  return computePercentFromEngine(normalizeCandidate(candidate, user), user);
}

/** Normalize list-row phone for display-side checks */
export function candidateRecordFromListRow(c) {
  if (!c) return null;
  return {
    ...c,
    contact: {
      ...(c.contact || {}),
      email: c.contact?.email || c.displayEmail,
      phone: c.contact?.phone || c.displayPhone
    },
    photo: c.photo || c.photoUrl || ''
  };
}
